import { render, staticRenderFns } from "./header-toolbar.vue?vue&type=template&id=6b4d81e5"
import script from "./header-toolbar.vue?vue&type=script&lang=js"
export * from "./header-toolbar.vue?vue&type=script&lang=js"
import style0 from "./header-toolbar.vue?vue&type=style&index=0&id=6b4d81e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports